import { getInstruction, BankFormState, CompanyFormState, CompanyFieldMetaData } from "shared/utils/fieldsHelper/companyFields";
import PhoneRow from "components/DetailPage/PhoneRow";
import { FormSection } from "components/MainSectionTemplate/types";
import { convertToPhoneNumbers, PhoneInput } from "components/PhoneInput";
import UrlInput from "components/urlinput";
import OptionalTextAreaInput, { OptionalTextAreaDetails } from "components/ValidatedFields/OptionalTextAreaInput";
import WebsiteLink from "components/Website/WebsiteLink";
import React from "react";

export const contactDetailSection = (
  formState: CompanyFormState,
  bankFormState: BankFormState,
  fieldMetaData: CompanyFieldMetaData
): FormSection => {
  return {
    type: "collapsable",
    title: RESX.Contact.ContactDetails,
    key: "contactDetailSection",
    fields: [
      {
        ...fieldMetaData.phone.fields(),
        key: "phone",
        label: RESX.ContactDetails.PhoneNumber,
        render: () => <PhoneRow numbers={convertToPhoneNumbers(formState.phone)} />,
        inPageEdit: {
          fullWidth: true,
          render: ({ value, onChange, submit, cancel }) => (
            <PhoneInput
              focusOnMount
              value={value}
              onChange={onChange}
              onEnter={submit}
              onEsc={cancel}
            />
          ),
          type: "confirmOrCancelButton",
          initialValue: formState.phone,
          submitChange: (value: string) => {
            const instruction = getInstruction(formState, bankFormState, {
              phoneNumbers: convertToPhoneNumbers(value),
            });

            return window.CoreApi.Company.Update(instruction);
          }
        }
      }, {
        ...fieldMetaData.website.fields(),
        key: "website",
        label: RESX.GeneralLabels.Website,
        render: () => <WebsiteLink website={formState.website} />,
        inPageEdit: {
          render: ({ value, onChange, cancel, submit }) => (
            <UrlInput
              focusOnMount
              value={value}
              onValueChange={onChange}
              validatorKey="companyWebsite"
              onEnter={submit}
              onEsc={cancel}
              maxLength={serverReference.constants.url.maxUrlLength}
            />
          ),
          type: "confirmOrCancelButton",
          initialValue: formState.website,
          fullWidth: true,
          submitChange: (value: string) => {
            const instruction = getInstruction(formState, bankFormState, {
              website: value,
            });

            return window.CoreApi.Company.Update(instruction);
          }
        }
      }, {
        ...fieldMetaData.facebook.fields(),
        key: "facebook",
        label: "Facebook",
        render: () => <WebsiteLink website={formState.facebook} />,
        inPageEdit: {
          render: ({ value, onChange, cancel, submit }) => (
            <UrlInput
              focusOnMount
              value={value}
              onValueChange={onChange}
              validatorKey="companyFacebook"
              onEnter={submit}
              onEsc={cancel}
              maxLength={serverReference.constants.url.maxFacebookLength}
            />
          ),
          type: "confirmOrCancelButton",
          initialValue: formState.facebook,
          fullWidth: true,
          submitChange: (value: string) => {
            const instruction = getInstruction(formState, bankFormState, {
              facebook: value,
            });

            return window.CoreApi.Company.Update(instruction);
          }
        }
      }, {
        ...fieldMetaData.networkPath.fields(),
        key: "networkPath",
        label: RESX.Company.NetworkPath,
        render: () => <WebsiteLink website={formState.networkPath} />,
        inPageEdit: {
          render: ({ value, onChange, cancel, submit }) => (
            <UrlInput
              focusOnMount
              value={value}
              onValueChange={onChange}
              validatorKey="companyNetworkPath"
              onEnter={submit}
              onEsc={cancel}
              maxLength={serverReference.constants.company.maxNetworkPathLength}
            />
          ),
          type: "confirmOrCancelButton",
          initialValue: formState.networkPath,
          fullWidth: true,
          submitChange: (value: string) => {
            const instruction = getInstruction(formState, bankFormState, {
              networkPath: value,
            });

            return window.CoreApi.Company.Update(instruction);
          }
        }
      },
      {
        ...fieldMetaData.additionInformation.fields(),
        key: "additional",
        label: RESX.Company.AdditionalInformation,
        render: () => <OptionalTextAreaDetails>{formState.additional}</OptionalTextAreaDetails>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }) => (
            <OptionalTextAreaInput
              focusOnMount
              value={value}
              onChange={v => onChange(v)}
              maxLength={serverReference.constants.company.maxAdditionalLength}
              onCtrlEnter={() => submit()}
              onEsc={() => cancel()}
            />
          ),
          type: "confirmOrCancelButton",
          initialValue: formState.additional,
          fullWidth: true,
          submitChange: (value: string) => {
            const instruction = getInstruction(formState, bankFormState, {
              additional: value,
            });

            return window.CoreApi.Company.Update(instruction);
          }
        }
      }
    ]
  }
}